import { createContext } from 'react';

// Tema/modo correnti del Centralino mobile, per i portali (sheet/player) che
// vivono fuori da .m-app e devono comunque ereditare le variabili colore.
export const MobileTheme = createContext({ theme: 'blue', mode: 'dark' });
